<script>
    import Card from '@/online_booking/new/components/common/Card';
    import GoogleAnalyticsEvents from 'Modules/GoogleAnalytics/resources/assets/js/GoogleAnalyticsEvents'

    export default {

        data: function () {
            return {
                event: null,
                event_group: null,
                events_overview_slug: events_overview_slug,
                signup: null,
                waiting_list_entry: null,
                externalConfirmationUrl: '',
                info: null,
                can_use_analytics: false,
            }
        },

        mounted: function () {

            this.$event_bus.$on('LoadEventData', (data) => {
                this.can_use_analytics = data.can_use_analytics;
                this.externalConfirmationUrl = data.online_booking_settings.external_confirmation_url;
            });

            this.$event_bus.$on('infoEventAdded', (data) => {
                this.event = data.event;
                this.event_group = data.event_group;
                this.signup = data.signup;
                this.waiting_list_entry = data.waiting_list_entry;
                this.info = data.data;

                const eventName = this.event_group ? this.event_group.name : this.event.name;

                if (this.can_use_analytics) {
                    let event_price = 0;

                    if (data.event.price_in_cents_with_vat) {
                        event_price = data.event.price_in_cents_with_vat;
                    }

                    GoogleAnalyticsEvents.EventSignup.send({
                        'event_category': system_name,
                        'event_label': eventName,
                        'value': parseInt(event_price) / 100,
                        'send_to': 'clientTracker',
                    });

                    if (data.payment) {
                        GoogleAnalyticsEvents.EventPaid.send({
                            'event_category': system_name,
                            'event_label': eventName,
                            'value': parseInt(data.payment.amount) / 100,
                            'send_to': 'clientTracker',
                        });
                    }
                }

                if (this.externalConfirmationUrl !== '') {
                    const redirectData = {
                        calendar: this.event.cal_id,
                        event_name: eventName,
                        start_time: this.event.start,
                        end_time: this.event.end,
                    };

                    const queryString = new URLSearchParams(redirectData).toString();

                    window.location.replace(`${this.externalConfirmationUrl}?${queryString}`);
                }
            });
        },

        computed: {
            eventName() {
                return this.event_group ? this.event_group.name : this.event.name;
            },

            event_date() {
                if (this.isMultipleDays) {
                    return moment(this.event.start).locale(moment_locale).format('LL, H:mm');
                } else {
                    return moment(this.event.start).locale(moment_locale).format('LL');
                }
            },

            event_time() {
                let end;

                if (this.isMultipleDays) {
                    end = moment(this.event.end).locale(moment_locale).format('LL, H:mm');
                } else {
                    end = moment(this.event.start).format('H:mm');
                    end += ' - ';
                    end += moment(this.event.end).format('H:mm');
                }

                return end;
            },

            successMessage() {
              if (this.waiting_list_entry) {
                return this.event_group
                    ? trans('waiting_list.course_subscription_success', {name: this.eventName, event_group_label: trans('event_groups.hardcoded_label')})
                    : trans('waiting_list.event_subscription_success', {name: this.eventName});
              } else {
                return this.event_group
                    ? trans('event_groups.subscription_success', {name: this.eventName, event_group_label: trans('event_groups.hardcoded_label').toLowerCase() })
                    : trans('events.subscription_success', {name: this.eventName});
              }
            },

            isMultipleDays () {
                return !moment(this.event.start).isSame(moment(this.event.end), 'day');
            }
        },

        components: {
            Card,
        },
    };


</script>


<template id="event-success">
    <div v-if="info && event" id="event-success-panel">
        <div class="row">
            <div class="col-xs-12">
                <card class="rounded-lg">
                    <div id="event-success-booking">
                        <div class="row">
                            <div class="col-xs-12 text-center m-t-40 m-b-30">
                                <i class="zmdi zmdi-check-circle booking-success-icon"></i>

                                <div v-if="event.is_filled && event.can_clients_singnup_for_waiting_list && waiting_list_entry">
                                  <h3 class="m-b-30">{{ trans('waiting_list.subscription_confirmed') }}</h3>
                                  <ep-banner class="m-b-30">
                                    <strong>{{ trans('online_booking.event_waiting_list_not_confirmation') }}</strong><br>
                                    <span>{{ trans('waiting_list.email.event_confirmation_info_2') }}</span>
                                  </ep-banner>
                                </div>
                                <h3 class="m-b-30" v-else>{{ successMessage }}.</h3>
                                <h3 class="m-b-30" v-if="signup && signup.is_paid_online">{{ trans('online_payment.receipt_received') }}</h3>

                                <router-link :to="'/overview/'+events_overview_slug" class="btn-lg btn-custom">
                                    <i class="zmdi zmdi-format-list-bulleted alert-ico"></i>
                                    <span class="m-l-10">{{ trans('events.goto_event_overview') }}</span>
                                </router-link>
                            </div>
                        </div>

                        <hr>

                        <div class="row m-t-30 m-b-20 flex flex-wrap justify-center">
                            <div class="col-xs-12 text-center" v-if="event_group">
                                <i class="zmdi zmdi-calendar-check booking-success-details-icon"></i>
                                <div>
                                    <h5>{{ this.event_group.interval_formatted }}</h5>
                                </div>
                            </div>
                            <div class="text-center col-xs-6 col-sm-4 " v-if="!event_group">
                                <i class="zmdi zmdi-calendar-check booking-success-details-icon" v-if="isMultipleDays"></i>
                                <i class="zmdi zmdi-calendar booking-success-details-icon" v-else></i>
                                <div>
                                    <h5>{{ event_date }}</h5>
                                </div>
                            </div>
                            <div class="text-center col-xs-6 col-sm-4" v-if="!event_group">
                                <i class="zmdi zmdi-calendar-close booking-success-details-icon" v-if="isMultipleDays"></i>
                                <i class="zmdi zmdi-time booking-success-details-icon" v-else></i>
                                <div>
                                    <h5>{{ event_time }}</h5>
                                </div>
                            </div>
                            <div class="text-center"
                                 v-if="event.address"
                                 :class="event_group ? 'col-xs-12':'col-xs-6 col-sm-4'"
                            >
                                <i class="zmdi zmdi-pin booking-success-details-icon"></i>
                                <div>
                                    <h5>
                                        {{ event.address }}<br>
                                        {{ event.zip }} {{ event.city }}
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>
